import React from 'react';
import KlaviyoLogo from '../icons/KlaviyoLogo';
import GoogleAdsLogo from '../icons/GoogleAdsLogo';
import ShopifyLogo from '../icons/ShopifyLogo';
import MetaLogo from '../icons/MetaLogo';
import { useNavigate } from 'react-router-dom';

function WeekView({ currentDate, events, showSuggestions }) {
  const navigate = useNavigate();
  const getWeekDays = (date) => {
    const week = [];
    const firstDayOfWeek = new Date(date);
    firstDayOfWeek.setDate(date.getDate() - date.getDay());

    for (let i = 0; i < 7; i++) {
      const day = new Date(firstDayOfWeek);
      day.setDate(firstDayOfWeek.getDate() + i);
      week.push(day);
    }
    return week;
  };

  const weekDays = getWeekDays(currentDate);
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  const renderPlatformIcons = (platforms) => {
    return (
      <div className="flex space-x-1">
        {platforms.map((platform) => {
          switch (platform) {
            case 'klaviyo':
              return <KlaviyoLogo key="klaviyo" className="h-4 w-4" />;
            case 'meta':
              return <MetaLogo key="meta" className="h-4 w-4" />;
            case 'shopify':
              return <ShopifyLogo key="shopify" className="h-4 w-4" />;
            case 'google-ads':
              return <GoogleAdsLogo key="google-ads" className="h-4 w-4" />;
            default:
              return null;
          }
        })}
      </div>
    );
  };

  const renderSuggestion = (event) => {
    return (
      <div className="border border-dashed border-purple-300 rounded-lg p-4 bg-purple-50/50 mb-2 flex flex-col">
        <div className="flex items-center space-x-1 text-purple-600 text-sm mb-2">
          <span>✨</span>
          <span>Suggestion</span>
        </div>
        <div className="flex items-center space-x-2 mb-2">
          <span className="text-gray-600">🎯 Campaign</span>
          {renderPlatformIcons(event.platforms)}
        </div>
        <h4 className="text-gray-800 font-medium mb-1">{event.title}</h4>
        {event.daysLeft && (
          <div className="flex items-center text-gray-500 text-sm mb-2">
            <span className="mr-2">📅 {event.daysLeft} days</span>
          </div>
        )}
        <p className="text-gray-600 text-sm mb-2">{event.description}</p>
        <button className="text-purple-600 text-sm hover:text-purple-700 mb-4">
          Show more
        </button>
        <div className="flex flex-col items-center space-y-2 mt-auto">
          <button
            onClick={() => navigate('/strategy/campaign/new')}
            className="w-32 px-4 py-2 border border-purple-300 rounded-md text-purple-600 text-sm font-medium hover:bg-purple-50"
          >
            {event.product ? 'Schedule' : 'Generate'}
          </button>
          <button className="text-gray-500 text-sm hover:text-gray-600">
            Dismiss
          </button>
        </div>
      </div>
    );
  };

  const renderEvent = (event) => {
    if (event.type === 'suggestion' && !showSuggestions) {
      return null;
    }

    if (event.type === 'suggestion') {
      return renderSuggestion(event);
    }

    return (
      <div
        key={event.title}
        className={`flex items-center space-x-2 rounded-md px-3 py-2 text-sm mb-2 ${
          event.type === 'campaign'
            ? 'bg-[#0049ac] text-white'
            : 'bg-white border border-gray-200 text-gray-700'
        }`}
      >
        {event.platform && (
          <div className="flex items-center space-x-1">
            {event.platform === 'klaviyo' && <KlaviyoLogo className="h-4 w-4" />}
            {event.platform === 'meta' && <MetaLogo className="h-4 w-4" />}
            {event.platform === 'shopify' && <ShopifyLogo className="h-4 w-4" />}
            {event.platform === 'google-ads' && <GoogleAdsLogo className="h-4 w-4" />}
          </div>
        )}
        {event.platforms && renderPlatformIcons(event.platforms)}
        <span className="flex-1 truncate">{event.title}</span>
      </div>
    );
  };

  return (
    <div className="flex flex-col h-full">
      {/* Header row with days */}
      <div className="grid grid-cols-7 border-b border-gray-200">
        {days.map((day, index) => (
          <div
            key={day}
            className={`p-4 text-sm font-medium ${
              index === 5 ? 'bg-[#0049ac] text-white rounded-full mx-2' : 'text-gray-900'
            }`}
          >
            {day}
          </div>
        ))}
      </div>

      {/* Calendar grid */}
      <div className="grid grid-cols-7 flex-1">
        {weekDays.map((date, dayIndex) => (
          <div
            key={date.toISOString()}
            className="min-h-[120px] p-4 border-r border-b border-gray-200 last:border-r-0"
          >
            <div className="text-sm text-gray-500 mb-2">{date.getDate()}</div>
            <div className="space-y-2">
              {events[date.getDate()]?.map((event, eventIndex) => (
                <div key={eventIndex}>{renderEvent(event)}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WeekView;